<ion-content [fullscreen]="true">
  <ion-row>
    <ion-col>
      <p>
        Intervention en cours ! Cette action sera réalisable à la fin de l’intervention !
      </p>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <div class="button-container">
        <ion-img src="../../../../assets/img/illustration_menage_no_background.png"></ion-img>
      </div>
    </ion-col>
  </ion-row>
</ion-content>